// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_js":"70a8f75a4ef34469","node_modules_canvg_lib_index_es_js":"61d445b5eb24486a"}[chunkId] + ".js";
};